import { m } from '~/paraglide/messages'
import type { CatalogueCurrency } from './catalogue-price'
import { intlLocale } from './params'

const numberFormatter = new Intl.NumberFormat(intlLocale)

const currencyLabel = { coin: m.coin, gem: m.time_crystal } as const

/** The caption a currency grant reads under: "Time Crystals × 30". */
export const currencyCaption = (currency: CatalogueCurrency, amount: number) =>
  `${currencyLabel[currency]()} × ${numberFormatter.format(amount)}`
